import { PaymentMethod } from "common/types";

import { useCreatePaymentMethodMutation } from "client/payments/hooks";
import PaymentForm from "client/payments/components/PaymentForm";
import { NON_CANCELED_NON_IMPORTED_SUBSCRIPTION_STATUSES } from "client/subscriptions/constants";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";
import { useSubscriptionBulkUpdatePaymentMethodDrawer } from "client/subscriptions/stackables";
import { usePrefetchPaginatedBasicSubscriptions } from "client/subscriptions/hooks";
import PrivacyDisclaimerTooltip from "client/common/components/content/PrivacyDisclaimerTooltip";

const AccountCreatePaymentDrawer = () => {
  const { close } = useCurrentDrawer();
  const prefetchBasicSubscriptions = usePrefetchPaginatedBasicSubscriptions();
  const { open: openSubscriptionBulkUpdatePaymentMethodDrawer } =
    useSubscriptionBulkUpdatePaymentMethodDrawer();

  const onCreatePaymentMethodSuccess = async (paymentMethod: PaymentMethod) => {
    try {
      const data = await prefetchBasicSubscriptions({
        visible_status: NON_CANCELED_NON_IMPORTED_SUBSCRIPTION_STATUSES,
        exclude_payment_method_id: paymentMethod.id,
        page: 1,
      });
      if (data.paginator.count > 0) {
        openSubscriptionBulkUpdatePaymentMethodDrawer({
          paymentMethod,
          onSuccess: close,
        });
        return;
      }
    } catch {
      // A failed picker prefetch should not strand the add-card form after the
      // card already exists — close so a retry does not create a duplicate.
    }
    close();
  };
  const {
    mutate: createPaymentMethod,
    isPending: isCreatingPaymentMethod,
    error,
  } = useCreatePaymentMethodMutation({
    onSuccess: onCreatePaymentMethodSuccess,
  });

  return (
    <DrawerLayout>
      <DrawerLayout.Header
        title={<PrivacyDisclaimerTooltip>Add payment method</PrivacyDisclaimerTooltip>}
        onClose={close}
      />
      <PaymentForm
        isLoading={isCreatingPaymentMethod}
        onSubmit={(id) => createPaymentMethod({ payment_method: id })}
        error={error}
      />
    </DrawerLayout>
  );
};

export default AccountCreatePaymentDrawer;
